import React, { useState, useRef, useEffect } from "react";
import SimpleReactValidator from 'simple-react-validator';
import { Input, LabelText, SubmitButton, FlexContainer, H1Text, Text, Spinner } from "../../design";
import { API } from "../../api";
import BaseSplitPage from "../../components/splitpage";
import Header from "./smallscreen/header";
import Support from "../../components/support";
import PaymentError from "../../components/paymenterror";
import { PAGES } from "../../appconstants";
import { notification } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";


type Props = {
    history: {
        push: Function,
    },
}

const AccountVerification = (props: Props) => {
    const [, forceUpdate] = useState();
    const [errorMessage, setErrorMessage] = useState('');
    const [showerrorMessage, setShowErrorMessage] = useState(false);
    const [verificationCode, setVerificationCode] = useState('');
    const [isShowSpinner, setShowSpinner] = useState(false);
    const [success, setSuccess] = useState(false);

    const { location: { search, pathname } } = props;
    const params = new URLSearchParams(search);
    const currentWalletPinGid = params.get('currentWalletPinGid');

    const phoneNumber = localStorage.getItem('phoneNumber');
    const otpRequestId = localStorage.getItem('otpRequestId');

    const simpleValidator = useRef(new SimpleReactValidator({
        validators: {
            otp: {
              message: 'Please enter a valid 6-digit OTP',
              rule: (val) => /^[a-zA-Z0-9]{6}$/.test(val),
            },
        },
    }));

    simpleValidator.current.purgeFields();

    const confirm = async () => {
            const formValid = simpleValidator.current.allValid();
            if (!formValid) {
                simpleValidator.current.showMessages();
                forceUpdate(1);
                return;
            }
            simpleValidator.current.hideMessages();
            setShowErrorMessage(false);
            forceUpdate();
        
            let params = {
                otp: verificationCode,
                phoneNumber,
                otpRequestId,
            };
            setShowSpinner(true);
            try {
                if(currentWalletPinGid){
                    const response = await API.post(`/rewards/wallet-pin/${currentWalletPinGid}/verify`,
                    { code: verificationCode },
                    {
                        headers: {
                            'RewardsAuthorization': `Bearer ${localStorage.getItem('rtpAccessToken')}`
                        },
                    });
                    if (response?.data.responseCode === 200) {
                        props.history.replace(PAGES.RTP_ADDED_BANKS);
                        notification.info({
                            className: "alert alert-success",
                            icon: <div className="d-flex align-items-center gap-8">
                            <InfoCircleOutlined style={{ fontSize: '20px' }} />
                            <span style={{ fontSize: '15px' }}>OTP verification success!</span>
                            </div>,
                            duration: 4,
                        })
                    }
                } else {
                    const { data: { entity } } = await API.post('/rewards/auth/authenticate', params);
                    if (entity && entity.token) {
                        localStorage.removeItem("phoneNumber");
                        localStorage.removeItem("otpRequestId");
                        localStorage.setItem("rtpAccessToken", entity.token.accessToken);
                        setSuccess(true);
                        notification.info({
                            className: "alert alert-success",
                            icon: <div className="d-flex align-items-center gap-8">
                            <InfoCircleOutlined style={{ fontSize: '20px' }} />
                            <span style={{ fontSize: '15px' }}>OTP verification success!</span>
                            </div>,
                            duration: 4,
                        })
                    };
                }
            } catch (e) {;
                setShowErrorMessage(true);
                setErrorMessage(e && e.data ? e?.data?.message : 'Unable to process request. Please try again later');
            } finally {
                setShowSpinner(false);
            }
    };

    useEffect(() => {
        if (success) {
            props.history.replace(PAGES.RTP_WALLET_PIN_SETUP);
        }
    }, [success]);

    const customInputStyle = {
        background: 'white',
        borderColor: '#CCCCCC',
        width: '21rem',
        height: '41px',
        paddingLeft: '15px',
    };
    
  
    return (
        <>
        <BaseSplitPage left={
            <>
                <FlexContainer
                    flexDirection="column"
                    position="relative"
                    display="block"
                    height="100%"
                >
                    <div>
                        <H1Text>
                            OTP VERIFICATION
                        </H1Text>
                    </div>
                    <div style={{ position: "sticky", top: "85%" }}>
                        <Support email={null}
                            phone={null} />
                    </div>
                </FlexContainer>
            </>
        } right={
            <>
                <Header payment={null} />
                <FlexContainer
                    className="pt-3 pt-lg-5 w-100 p-2"
                    box-shadow="0 0 15px 0 rgba(0, 0, 0, 0.1)"
                    display="flow-root"
                    backgroundColor="#fff"
                    borderRadius="10px"
                    marginTop="5%"
                    marginBottom="5%"
                >

                    <H1Text
                        className="px-1 px-md-4 mt-4"
                    >
                        VERIFY YOUR RTP ONE TIME PASSWORD
                    </H1Text>
                    <div className="px-1 px-md-4 mt-2">
                        <FlexContainer
                            flexDirection="column"
                        >
                            <Text fontSize="15px" marginTop="2px" marginBottom="4px">
                              Enter the otp you received from the mobile phone to complete verification.
                            </Text>
                            <div>
                                <LabelText style={{ color: 'black' }} className="mb-1">
                                    OTP Code
                                </LabelText>
                                <Input
                                    style={customInputStyle}
                                    value={verificationCode}
                                    onChange={(e) => {
                                        setVerificationCode(e.target.value);
                                    }}
                                />
                                {
                                <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">
                                    {simpleValidator.current.message('verification code', verificationCode, 'required|otp')}
                                </Text>
                                }
                            </div>
                            <div style={{ paddingLeft: '0px', paddingTop: '8px' }}>
                                <SubmitButton
                                    type="submit"
                                    marginTop="0px !importnat"
                                    // style={{ width: '142px' }}
                                    style={{ width: '21rem' }}
                                    onClick={() => confirm()}
                                >
                                  CONFIRM
                                </SubmitButton>
                            </div>
                        </FlexContainer>
                    </div>
                </FlexContainer>
                <Spinner isOpen={isShowSpinner} />
                {showerrorMessage && <PaymentError header={"Error"} message={errorMessage} />}
            </>
        } />
        </>
    )
};

export default AccountVerification;
